// The 100 counties of North Carolina with their county seats.
// slug = lowercase name with spaces -> hyphens (e.g. "New Hanover" -> "new-hanover").
const RAW = [
  ["Alamance", "Graham"], ["Alexander", "Taylorsville"], ["Alleghany", "Sparta"], ["Anson", "Wadesboro"],
  ["Ashe", "Jefferson"], ["Avery", "Newland"], ["Beaufort", "Washington"], ["Bertie", "Windsor"],
  ["Bladen", "Elizabethtown"], ["Brunswick", "Bolivia"], ["Buncombe", "Asheville"], ["Burke", "Morganton"],
  ["Cabarrus", "Concord"], ["Caldwell", "Lenoir"], ["Camden", "Camden"], ["Carteret", "Beaufort"],
  ["Caswell", "Yanceyville"], ["Catawba", "Newton"], ["Chatham", "Pittsboro"], ["Cherokee", "Murphy"],
  ["Chowan", "Edenton"], ["Clay", "Hayesville"], ["Cleveland", "Shelby"], ["Columbus", "Whiteville"],
  ["Craven", "New Bern"], ["Cumberland", "Fayetteville"], ["Currituck", "Currituck"], ["Dare", "Manteo"],
  ["Davidson", "Lexington"], ["Davie", "Mocksville"], ["Duplin", "Kenansville"], ["Durham", "Durham"],
  ["Edgecombe", "Tarboro"], ["Forsyth", "Winston-Salem"], ["Franklin", "Louisburg"], ["Gaston", "Gastonia"],
  ["Gates", "Gatesville"], ["Graham", "Robbinsville"], ["Granville", "Oxford"], ["Greene", "Snow Hill"],
  ["Guilford", "Greensboro"], ["Halifax", "Halifax"], ["Harnett", "Lillington"], ["Haywood", "Waynesville"],
  ["Henderson", "Hendersonville"], ["Hertford", "Winton"], ["Hoke", "Raeford"], ["Hyde", "Swan Quarter"],
  ["Iredell", "Statesville"], ["Jackson", "Sylva"], ["Johnston", "Smithfield"], ["Jones", "Trenton"],
  ["Lee", "Sanford"], ["Lenoir", "Kinston"], ["Lincoln", "Lincolnton"], ["Macon", "Franklin"],
  ["Madison", "Marshall"], ["Martin", "Williamston"], ["McDowell", "Marion"], ["Mecklenburg", "Charlotte"], ["Mitchell", "Bakersville"],
  ["Montgomery", "Troy"], ["Moore", "Carthage"], ["Nash", "Nashville"], ["New Hanover", "Wilmington"],
  ["Northampton", "Jackson"], ["Onslow", "Jacksonville"], ["Orange", "Hillsborough"], ["Pamlico", "Bayboro"],
  ["Pasquotank", "Elizabeth City"], ["Pender", "Burgaw"], ["Perquimans", "Hertford"], ["Person", "Roxboro"],
  ["Pitt", "Greenville"], ["Polk", "Columbus"], ["Randolph", "Asheboro"], ["Richmond", "Rockingham"],
  ["Robeson", "Lumberton"], ["Rockingham", "Wentworth"], ["Rowan", "Salisbury"], ["Rutherford", "Rutherfordton"],
  ["Sampson", "Clinton"], ["Scotland", "Laurinburg"], ["Stanly", "Albemarle"], ["Stokes", "Danbury"],
  ["Surry", "Dobson"], ["Swain", "Bryson City"], ["Transylvania", "Brevard"], ["Tyrrell", "Columbia"],
  ["Union", "Monroe"], ["Vance", "Henderson"], ["Wake", "Raleigh"], ["Warren", "Warrenton"],
  ["Washington", "Plymouth"], ["Watauga", "Boone"], ["Wayne", "Goldsboro"], ["Wilkes", "Wilkesboro"],
  ["Wilson", "Wilson"], ["Yadkin", "Yadkinville"], ["Yancey", "Burnsville"],
];

export const toSlug = (name) => name.toLowerCase().replace(/\s+/g, "-");

export const NC_COUNTIES = RAW.map(([name, seat]) => ({ name, seat, slug: toSlug(name) }));

// Most populous counties — used for form→county internal linking.
export const TOP_COUNTIES = [
  "Mecklenburg", "Wake", "Guilford", "Forsyth", "Cumberland", "Durham",
  "Buncombe", "Union", "Gaston", "New Hanover", "Cabarrus", "Johnston",
].map((name) => ({ name, slug: toSlug(name) }));

export const getCounty = (slug) => NC_COUNTIES.find((c) => c.slug === slug);
